export default function mapLabelsDirective() {
	"ngInject";

	return {
		restrict: "E",
		replace: true,
		templateUrl: "./components/map-labels/map-labels-template.html",
		scope: {
			options: "=",
			onChange: "&"
		},
		bindToController: true,
		controllerAs: "vm",
		controller: function () {
			"ngInject";

			const vm = this;

			vm.$onInit = () => {
				const defaultOptions = {
					active: true
				};
				angular.extend(vm.options, defaultOptions, vm.options);

				vm.setOption(vm.options.active);
			};


			vm.updateOptions = () => {
				vm.setOption(vm.options.active);

				if (vm.onChange) {
					vm.onChange();
				}
			};

			vm.setOption = (active) => {
				vm.label = active ? "pros-maps.map.options.shown" : "pros-maps.map.options.hidden";
			};
		}
	};
}
